import { styled } from "@vitality-ds/system";
import { BaseSpinnerWrapper } from "./styles/BaseSpinnerWrapper.styles";

// eslint-disable-next-line import/prefer-default-export
export var SpinnerWrapper = styled("div", BaseSpinnerWrapper);